import React from 'react';

// Peerlist brand mark — minimal PL monogram on a diamond / rounded-square.
// SVG-only, inherits currentColor for easy dark/light theming and avoids a
// network request + CSP headache that a raster logo would bring.
interface PeerlistIconProps {
  size?: number;
  className?: string;
  ariaLabel?: string;
}

const PeerlistIcon: React.FC<PeerlistIconProps> = ({
  size = 14,
  className = '',
  ariaLabel = 'Peerlist',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    className={className}
    role="img"
    aria-label={ariaLabel}
  >
    <rect x="2" y="2" width="20" height="20" rx="6" fill="#00AA45" />
    <path
      d="M8.5 7h4.2c2.3 0 4 1.5 4 3.7s-1.7 3.7-4 3.7H10.5V17H8.5V7zm2 5.4h2c1.1 0 1.9-.6 1.9-1.7s-.8-1.7-1.9-1.7h-2v3.4z"
      fill="#FFFFFF"
    />
  </svg>
);

export default React.memo(PeerlistIcon);
